import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Icon } from '@iconify/react/dist/iconify.js';
import { ADMISSION_CONFIRMED, PHASES, getWorkflowStageNo, stageByNo } from '../constants/stages';

// Student status cell for the CRO Leads tables: the retention workflow stage (phase-coloured) for every student.
// Stage 7 is the existing "Admission Confirmed" status. Before that, the student's current contact status
// (Waiting For Response, Demo Class Scheduled, …) is shown underneath so it isn't lost.
export default function WorkflowStageChip({ row }) {
  const stage = stageByNo(getWorkflowStageNo(row));
  const salesStatus = row?.student_status;

  if (!stage) {
    return salesStatus ? <Chip variant="outlined" color="warning" label={salesStatus} /> : null;
  }

  const phase = PHASES[stage.phase];
  const showSales = salesStatus && salesStatus.trim().toLowerCase() !== ADMISSION_CONFIRMED.toLowerCase();

  return (
    <Stack gap={0.25} alignItems="flex-start">
      <Tooltip title={`${phase.label} · ${stage.name}`}>
        <Chip
          size="small"
          icon={<Icon icon={stage.icon} width={15} />}
          label={`${stage.no} · ${stage.short}`}
          sx={{
            height: 26,
            borderRadius: '8px',
            fontWeight: 700,
            fontSize: 12,
            bgcolor: alpha(phase.color, 0.12),
            color: phase.color,
            '& .MuiChip-icon': { color: phase.color, ml: '6px' },
          }}
        />
      </Tooltip>
      {showSales && (
        <Typography variant="caption" color="text.secondary" sx={{ pl: 0.5, fontSize: 11.5 }}>
          {salesStatus}
        </Typography>
      )}
    </Stack>
  );
}
